import Button from "@material-ui/core/Button";
import DescriptionIcon from "@material-ui/icons/Description";
import GetAppIcon from "@material-ui/icons/GetApp";
import { Storage } from "aws-amplify";
import React, { useEffect, useRef, useState } from "react";

import Grid from "@material-ui/core/Grid";

import LinearProgress from "@material-ui/core/LinearProgress";
import AlarmOnIcon from "@material-ui/icons/AlarmOn";
import { Auth } from "aws-amplify";
import { useParams } from "react-router-dom";

import "./TestingForm.css";

const TestingForm = (props) => {
  let { uname, pname } = useParams();
  const hiddenFileInput = useRef(null);

  const [dataRead, setDataRead] = useState(0);
  const [modeldata, setModelData] = useState([]);
  const [algoType, setAlgotype] = useState("");
  const [fileData, setFileData] = useState("");
  const [csvData, setCsvData] = useState("");
  const [inputVariables, setInputVariables] = useState([]);
  const [filename, setFileName] = useState("");
  const [imgPath, setImgPath] = useState("");
  const [open, setOpen] = React.useState(false);
  const [predictionResult, setPredictionResult] = useState("");
  const [progressBar, setProgressBar] = useState(false);
  const [downloadAvailable, setDownloadAvailable] = useState(false);

  var oldDate, newDate;

  const downloadResults = () => {
    let urls = [
      `https://eduvancewebai.s3.ap-south-1.amazonaws.com/projects/${Auth.user.username}/${pname === undefined ? "untitled" : pname}_validation.csv`,
    ];
    urls.forEach(function (e) {
      const link = document.createElement("a");
      link.href = e;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  const onFinalSubmission = async () => {
    setProgressBar(true);
    setPredictionResult("");
    let mapping = {};
    mapping["username"] = Auth.user.username;
    mapping["project"] = pname === undefined ? "untitled" : pname;

    if (algoType === "IC") {
      await Storage.remove(mapping["username"] + "/testimage.jpg");
      await Storage.put(mapping["username"] + "/testimage.jpg", fileData, {
        contentType: "image/jpg",
      });

      var data = JSON.stringify(mapping);
      var xhr = new XMLHttpRequest();

      xhr.addEventListener("readystatechange", function () {
        if (this.readyState === 4) {
          // console.log(this.responseText);
          try {
            let tempjson = JSON.parse(this.responseText);
            let tempjson2 = JSON.parse(tempjson["body"]);
            //  console.log(tempjson2['value']);
            setPredictionResult(tempjson2["message"] + tempjson2["value"]);
            // console.log(predictionResult);
            setProgressBar(false);
          } catch {
            //console.log("in catch");
            onFinalSubmission();
          }
        }
      });

      xhr.open(
        "POST",
        "https://s2v68e8y9a.execute-api.ap-south-1.amazonaws.com/dev/test",
      );
      xhr.setRequestHeader("Content-Type", "application/json");

      xhr.send(data);
    } else {
      let temp = document.querySelectorAll('[id^="ipt"]');
      var temparrayinput = [[]];
      //  console.log("ip list" + inputVariables);
      temp.forEach((e) => {
        temparrayinput[0].push(parseFloat(e.value));
      });
      mapping["value"] = temparrayinput;

      xhr.addEventListener("readystatechange", function () {
        if (this.readyState === 4) {
          try {
            let tempjson = JSON.parse(this.responseText);
            let tempjson2 = JSON.parse(tempjson["body"]);
            //   console.log(tempjson2['value']);
            setPredictionResult(
              <>
                <span>{tempjson2["message"]}</span> <br />
                <span style={{ fontSize: "21px" }}>{tempjson2["value"]}</span>
              </>,
            );
            //   console.log(predictionResult);
            setProgressBar(false);
          } catch {
            //  console.log("in catch");
            onFinalSubmission();
          }
        }
      });

      xhr.open(
        "POST",
        "https://s2v68e8y9a.execute-api.ap-south-1.amazonaws.com/dev/test",
      );
      xhr.setRequestHeader("Content-Type", "application/json");

      xhr.send(data);
    }
  };

  const handleFileUpload = (element) => {
    let e = element;
    const file = e.target.files[0];
    var fileName = e.target.value.split("\\");
    setFileName(fileName[fileName.length - 1]);

    setFileData(e.target.files[0]);

    var temppath = URL.createObjectURL(e.target.files[0]);
    // console.log("img path" + temppath);
    setImgPath(temppath);
  };

  useEffect(() => {
    var xmlhttp = new XMLHttpRequest();
    xmlhttp.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        var myObj = JSON.parse(this.responseText);
        var testdata = [];
        if (myObj["algorithm"] === "IC") {
          setAlgotype("IC");
        } else {
          setAlgotype("ML");
          myObj["inputs"].forEach((element) => {
            testdata.push(
              <div key={element} className="card-body text-center text-white">
                <Grid spacing={1}>
                  <Grid item xs>
                    {`${element} : `}
                    <input
                      type="text"
                      className="myinput"
                      id={`ipt${element}`}
                    />
                  </Grid>
                </Grid>
              </div>,
            );
          });
        }
        setModelData(testdata);
        setDataRead(1);
        //console.log("here are inputs" + myObj["inputs"]);
        setInputVariables(myObj["inputs"]);
      }
    };
    xmlhttp.open(
      "GET",
      `https://eduvancewebai.s3.ap-south-1.amazonaws.com/projects/${Auth.user.username}/${pname === undefined ? "untitled" : pname}_config.json`,
      true,
    );
    xmlhttp.send();
  }, []);

  function getConfigDate(url, wch) {
    try {
      var req = new XMLHttpRequest();
      req.open("GET", url, false);
      req.setRequestHeader("Cache-Control", "no-cache");
      req.send(null);
      if (req.status == 200) {
        return new Date(req.getResponseHeader(wch));
      } else return false;
    } catch (er) {
      return er.message;
    }
  }

  const handleClick = (event) => {
    try {
      hiddenFileInput.current.click();
    } catch (er) {
      // console.log(er.message);
    }
  };

  const handleChange = async (event) => {
    setProgressBar(true);
    setDownloadAvailable(false);
    const fileUploaded = event.target.files[0];
    setCsvData(fileUploaded);
    //console.log("file name " + fileUploaded.name);
    await Storage.remove(
      Auth.user.username +
        `/${pname === undefined ? "untitled" : pname}_validation.csv`,
    );
    await Storage.put(
      Auth.user.username +
        `/${pname === undefined ? "untitled" : pname}_validation.csv`,
      fileUploaded,
    );
    oldDate = getConfigDate(
      `https://eduvancewebai.s3.ap-south-1.amazonaws.com/projects/${Auth.user.username}/${pname === undefined ? "untitled" : pname}_validation.csv`,
      "Last-Modified",
    );

    let mapping = {};
    mapping["username"] = Auth.user.username;
    mapping["project"] = pname === undefined ? "untitled" : pname;
    mapping["bulktest"] = "true";
    mapping["testfile"] =
      `https://eduvancewebai.s3.ap-south-1.amazonaws.com/projects/${Auth.user.username}/${pname === undefined ? "untitled" : pname}_validation.csv`;
    // console.log("here is mapping " + JSON.stringify(mapping));

    var data = JSON.stringify(mapping);
    var xhr = new XMLHttpRequest();

    xhr.addEventListener("readystatechange", function () {
      if (this.readyState === 4) {
        try {
          // console.log("value " + this.responseText);
          let valjson = JSON.parse(this.responseText);
          let mjson = JSON.parse(valjson["body"]);
          console.log("response", mjson);
          if (mjson["message"] === "file uploaded") {
            setProgressBar(false);
            setDownloadAvailable(true);
          }
        } catch {
          console.log("in catch");
          var timerfun = setInterval((timerfun) => {
            //   console.log("old date " + oldDate);
            newDate = getConfigDate(
              `https://eduvancewebai.s3.ap-south-1.amazonaws.com/projects/${Auth.user.username}/${pname === undefined ? "untitled" : pname}_config.json`,
              "Last-Modified",
            );

            console.log("new date " + newDate);
            if (newDate > oldDate) {
              clearInterval(timerfun);
              setProgressBar(false);
            }
          }, 5000);
        }
      }
    });

    xhr.open(
      "POST",
      "https://s2v68e8y9a.execute-api.ap-south-1.amazonaws.com/dev/test",
    );
    xhr.setRequestHeader("Content-Type", "application/json");

    xhr.send(data);
  };

  return (
    <div>
      {dataRead ? (
        <section>
          <div className="container">
            <div className="btn-container">
              {predictionResult}
              {/* <br /><br /> */}
              <Button
                style={{ marginTop: "5%" }}
                variant="contained"
                color="primary"
                component="span"
                startIcon={<AlarmOnIcon />}
                onClick={onFinalSubmission}
              >
                Test
              </Button>

              <input
                type="file"
                accept=".csv"
                ref={hiddenFileInput}
                id="file-1"
                style={{ display: "none" }}
                onChange={handleChange}
              />

              <Button
                variant="contained"
                color="primary"
                component="span"
                startIcon={<DescriptionIcon />}
                onClick={handleClick}
                style={{ marginLeft: "3vw", marginTop: "5%" }}
              >
                Bulk Test
              </Button>

              {downloadAvailable ? (
                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  component="span"
                  startIcon={<GetAppIcon />}
                  onClick={downloadResults}
                  style={{ marginLeft: "3vw", marginTop: "5%" }}
                >
                  Download result
                </Button>
              ) : (
                <></>
              )}
            </div>
            <div className="card-body text-white text-center pt-0">
              {progressBar ? (
                <LinearProgress style={{ marginTop: "1rem" }} />
              ) : (
                ""
              )}
            </div>
            {modeldata}
            {algoType === "IC" ? (
              <div className="card-body text-center text-white">
                {filename === "" ? (
                  <p> No File Uploaded </p>
                ) : (
                  <React.Fragment>
                    <img src={imgPath} alt="img-path" />
                    <p> {filename}</p>
                  </React.Fragment>
                )}
                <label htmlFor="contained-button-file">
                  <Button variant="contained" color="primary" component="span">
                    Select
                  </Button>
                </label>

                <input
                  hidden="true"
                  accept=".jpg"
                  id="contained-button-file"
                  type="file"
                  onChange={handleFileUpload}
                />
              </div>
            ) : (
              ""
            )}
          </div>
        </section>
      ) : (
        <section>
          <div className="container">
            <div className="row align-items-center justify-content-center">
              <div className="col-3 ">
                <span>Please train the machine.</span>
              </div>
            </div>
          </div>
        </section>
      )}
    </div>
  );
};

export default TestingForm;
